export const priceToNumber = (price?: string | number | null) =>
  price == null ? 0 : typeof price === 'string' ? Number(price.replace(/[^0-9.]/g, '')) : price;
